export const formatYearPlural = (value: number) => {
  switch (new Intl.PluralRules('ru-RU').select(value)) {
    case 'one':
      return 'год';
    case 'few':
      return 'года';
    case 'many':
      return 'лет';
    default:
      return 'лет';
  }
};
